import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { FormField } from '@/components/ui/form/form-field'
import {
  FORM_ID,
  type FormValues,
  schema,
} from '@/dialogs/EditSalesTemplateDialog/validation.ts'
import { useSalesEditor } from '@/modules/sales-editor/hooks/use-sales-editor.ts'
import { type SalesEditorTemplate } from '@/modules/sales-editor/state/types'

import { type DialogProps } from '../types'

interface Props extends DialogProps {
  template: SalesEditorTemplate
}

export const EditSalesTemplateDialog = ({
  isOpen,
  onClose,
  template,
}: Props) => {
  const { updateTemplate } = useSalesEditor()
  const form = useForm<FormValues>({
    defaultValues: {
      name: template.name,
    },
    resolver: zodResolver(schema),
  })

  const onSubmit = ({ name }: FormValues) => {
    updateTemplate(template!.id, name)
    onClose()
  }

  return (
    <Dialog
      bigDialog
      show={isOpen}
      onClose={onClose}
      childrenClassName="space-y-6"
      panelClassName="lg:max-w-[560px]"
    >
      <Dialog.Header>
        <Dialog.Title>Edit Template</Dialog.Title>
      </Dialog.Header>

      <FormProvider {...form}>
        <form
          id={FORM_ID}
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <FormField
            name="name"
            label="Template name"
          />
        </form>
      </FormProvider>

      <Dialog.ClosableFooter onClose={onClose}>
        <Button
          form={FORM_ID}
          type="submit"
          disabled={!form.formState.isValid || !form.formState.isDirty}
        >
          Save
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
